// Make every app modal draggable by its header — one delegated listener for all of them.
// Reactstrap renders `.modal-dialog > .modal-content > .modal-header`; we move the dialog.
// Position is stored on the dialog element, so it resets automatically when a modal reopens
// (each open mounts a fresh `.modal-dialog`). Call enableModalDragging() once at app start.

let installed = false

export function enableModalDragging() {
  if (installed || typeof document === "undefined") return
  installed = true

  // cursor affordance on draggable headers
  const style = document.createElement("style")
  style.textContent = `.modal-header{cursor:move;} .modal-header .btn-close,.modal-header .close{cursor:pointer;}`
  document.head.appendChild(style)

  let drag = null

  const onMove = e => {
    if (!drag) return
    const pos = {
      x: drag.baseX + (e.clientX - drag.startX),
      y: drag.baseY + (e.clientY - drag.startY),
    }
    drag.dialog._dragPos = pos
    drag.dialog.style.transform = `translate(${pos.x}px, ${pos.y}px)`
  }
  const onUp = () => {
    drag = null
    document.removeEventListener("mousemove", onMove)
    document.removeEventListener("mouseup", onUp)
  }

  document.addEventListener("mousedown", e => {
    const header = e.target.closest && e.target.closest(".modal-header")
    if (!header) return
    // let interactive elements in the header work normally (close button, inputs, links)
    if (e.target.closest("button, .btn-close, .close, a, input, select, textarea")) return
    const dialog = header.closest(".modal-dialog")
    if (!dialog) return
    const base = dialog._dragPos || { x: 0, y: 0 }
    drag = { dialog, startX: e.clientX, startY: e.clientY, baseX: base.x, baseY: base.y }
    document.addEventListener("mousemove", onMove)
    document.addEventListener("mouseup", onUp)
    e.preventDefault()
  })
}
